import { render, staticRenderFns } from "./index_v1.vue?vue&type=template&id=70cc8e61&scoped=true"
import script from "./index_v1.vue?vue&type=script&lang=js"
export * from "./index_v1.vue?vue&type=script&lang=js"
import style0 from "./index_v1.vue?vue&type=style&index=0&id=70cc8e61&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cc8e61",
  null
  
)

export default component.exports